<ng-template #content let-c="close" let-d="dismiss">
    <form name="frmOperation" (submit)="onSubmit()">
        <div class="modal-header">
            <h6 class="modal-title">{{Title | translate}} <span *ngIf="JobData"> ({{JobData.DisplayCallNo}} | {{JobData.CallDescription}})</span></h6>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <div class="container-fluid" *ngIf="Model">
                <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>

                <div class="" *ngIf="Mode==_JobOperationActions.Close">

                    <div class="form-group">
                        <select class="custom-select" id="ClosedReasonCode_Close" [(ngModel)]="Model.ClosedReasonCode_Close" name="ClosedReasonCode_Close">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_CLOSE_RASON</option>
                            <option *ngFor="let row of masterService.GetReasonTypes(Model.PropertyId, 'CLSR')" [value]="row.ID">{{row.Description}}</option>
                        </select>
                    </div>

                       <div class="form-group" *ngIf="inventorySingularityEnabled && Model.InventoryJobMappings && (inventoryItempType == InventoryItemType.Reusable || inventoryItempType == InventoryItemType.Consumables)">
                            <span translate>LBL.LBL_INVENTORY_ITEM_USED</span>
                            <input class="form-control" [value]="Model.InventoryJobMappings.Name" disabled />
                            <div class="text-sm">
                                {{ 'LBL.LBL_STOCK_IN_HAND' | translate }}:
                                <span class="highlight_Color">{{ Model.InventoryJobMappings.AvailableQuantity }}</span>
                            </div>
                    </div>

                    <div class="flex flex-row gap-8" *ngIf="inventorySingularityEnabled && Model.InventoryJobMappings">
                        <!-- shall we need to validate the number, for 0 or negative -->
                        <div class="form-group w-full" *ngIf="inventoryItempType == InventoryItemType.Reusable || inventoryItempType == InventoryItemType.Consumables">
                            <span translate>LBL.LBL_QUANTITY_UTILIZED</span>
                            <input class="form-control" type="number"
                                [(ngModel)]="Model.InventoryJobMappings.DefaultQuantity"
                                name="DefaultQuantity"
                                />
                        </div>
                        <div class="form-group w-full" *ngIf="this.inventoryItempType == InventoryItemType.Reusable && JobInventoryLocations">
                            <span translate>LBL.LBL_STORE_LOCATION</span>
                            <ng-select
                                [items]="JobInventoryLocations.JobInventoryLocations"
                                bindLabel="LocationName"
                                [multiple]="false"
                                [closeOnSelect]="true"
                                bindValue="locationId"
                                placeholder="{{'PH.PH_STORE_LOCATION' | translate}}"
                                name="locationId"
                                [(ngModel)]="Model.InventoryJobMappings.StockLocationId"
                                [virtualScroll]="true"
                            >
                            </ng-select>
                        </div>
                    </div>

                    <div class="form-group flex flex-row gap-8" *ngIf="inventoryItempType == InventoryItemType.Reusable && inventorySingularityEnabled">
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 mr-1">
                                <span translate>LBL.LBL_INV_UTILIZED_FROM</span>
                            </div>
                            <div class="col-auto">
                                <div class="input-group" >
                                    <p-calendar
                                        name="GuestCheckInAt"
                                        [(ngModel)]="guestInventoryDetail.GuestCheckInAt"
                                        placeholder="{{'PH.PH_YYYY_MM_DD' | translate}}"
                                        dateFormat="yy/mm/dd"
                                        hideOnDateTimeSelect="true"
                                        [minDate]="JobData.RegisteredAt"
                                        showTime="true"
                                        hourFormat="12"
                                        showIcon="true"
                                        styleClass=""
                                    ></p-calendar>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center no-gutters">
                            <div class="col-12 mr-1">
                                <span translate>LBL.LBL_INV_UTILIZED_TILL</span>
                            </div>
                            <div class="col-auto">
                                <div class="input-group">
                                    <p-calendar
                                        name="GuestCheckOutAt"
                                        [(ngModel)]="guestInventoryDetail.GuestCheckOutAt"
                                        placeholder="{{'PH.PH_YYYY_MM_DD' | translate}}"
                                        dateFormat="yy/mm/dd"
                                        hideOnDateTimeSelect="true"
                                        showTime="true"
                                        hourFormat="12"
                                        showIcon="true"
                                        styleClass=""
                                        [disabled]="!guestInventoryDetail.GuestCheckInAt ? true : false"
                                        [minDate]="guestInventoryDetail.GuestCheckInAt" 
                                    ></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
            
                    
                    <div class="form-group">
                        <!--<label translate>LBL.REMARKS</label>-->
                        <RemarksPopupTrigger [(Model)]="Model.LastActionRemarks">
                            <textarea class="form-control" [(ngModel)]="Model.LastActionRemarks" name="Close_Remarks" id="Close_Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                        </RemarksPopupTrigger>
                    </div>

                </div>

                <div class="" *ngIf="Mode == _JobOperationActions.Park">
                    <div class="form-group"><ParkEntry #parkEntry [Model]="Model"></ParkEntry></div>

                    <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="park_Reassign_Auto" name="park_Reassign_auto" class="custom-control-input" [value]="true" [(ngModel)]="Model.IsAutoAssign" (change)="onAssignmentChange()">
                            <label class="custom-control-label" for="park_Reassign_Auto" translate>LBL.AUTO_ASSIGN</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="park_Reassign_Same" name="park_Reassign_same" class="custom-control-input" [value]="" [(ngModel)]="Model.IsAutoAssign" (change)="onAssignmentChange()" [disabled]="JobData && JobData.CurrentStatus == _CallStatuses.Unassigned">
                            <label class="custom-control-label" for="park_Reassign_Same" translate>LBL.ASSIGN_TO_SAME_STAFF</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="park_Reassign_Manual" name="park_Reassign_manual" class="custom-control-input" [value]="false" [(ngModel)]="Model.IsAutoAssign" (change)="onAssignmentChange()">
                            <label class="custom-control-label" for="park_Reassign_Manual" translate>LBL.MANUAL_ASSIGNMENT</label>
                            <div class="ml-2" *ngIf="Model.IsAutoAssign == false"><span translate>LBL.ASSIGN_TO</span>: <span>{{AssignToName}} <a href="javascript:{}" (click)="onAssignmentChange()"><span translate>LBL.CHANGE</span></a></span></div>
                        </div>
                    </div>

                    <div class="form-group">
                        <RemarksPopupTrigger [(Model)]="Model.LastActionRemarks">
                            <textarea class="form-control" [(ngModel)]="Model.LastActionRemarks" name="Park_Remarks" id="Park_Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                        </RemarksPopupTrigger>
                    </div>
                </div>

                <div class="" *ngIf="Mode == _JobOperationActions.AddRemarks">
                    <div class="form-group">
                        <RemarksPopupTrigger [(Model)]="Model.Remarks">
                            <textarea class="form-control" [(ngModel)]="Model.Remarks" name="Add_Remarks" id="Add_Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                        </RemarksPopupTrigger>
                    </div>
                </div>

                <div class="" *ngIf="Mode == _JobOperationActions.Reset">
                    <div class="form-group">
                        <select class="custom-select" id="ClosedReasonCode_Reset" [(ngModel)]="Model.ClosedReasonCode" name="ClosedReasonCode_Reset">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_RESET_REASON</option>
                            <option *ngFor="let row of masterService.GetReasonTypes(Model.PropertyId, 'RSTR')" [value]="row.ID">{{row.Description}}</option>
                        </select>
                    </div>
                    <div class="form-group d-flex align-items-center">
                        <label class="mr-2 req" translate>LBL.EXTRA_TIME_REQ</label>
                        <div class="d-flex align-items-center">
                            <input class="form-control txt-3 mr-1" type="text" [(ngModel)]="Reset_Hours" mask="000" (change)="onResetHoursChanged()" name="Reset_Hours" id="Reset_Hours" />
                            <div class="mr-2"><span translate>LBL.HOURS</span></div>
                            <input class="form-control txt-3 mr-1" type="text" [(ngModel)]="Reset_Minutes" mask="000" (change)="onResetMinutesChanged()" name="Reset_Minutes" id="Reset_Minutes" />
                            <div><span translate>LBL.MINUTES</span></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <RemarksPopupTrigger [(Model)]="Model.LastActionRemarks">
                            <textarea class="form-control" [(ngModel)]="Model.LastActionRemarks" name="Reset_Remarks" id="Reset_Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                        </RemarksPopupTrigger>
                    </div>
                </div>

                <div class="" *ngIf="Mode == _JobOperationActions.Reopen">
                    <div class="form-group">
                        <select class="custom-select" id="ClosedReasonCode_Reopen" [(ngModel)]="Model.ClosedReasonCode" name="ClosedReasonCode_Reopen">
                            <option [value]="0" translate>CMB_DEF.CMB_DEF_SELECT_REOPEN_REASON</option>
                            <option *ngFor="let row of masterService.GetReasonTypes(Model.PropertyId, 'REOPR')" [value]="row.ID">{{row.Description}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <RemarksPopupTrigger [(Model)]="Model.LastActionRemarks">
                            <textarea class="form-control" [(ngModel)]="Model.LastActionRemarks" name="Reopen_Remarks" id="Reopen_Remarks" placeholder="{{'PH.PH_ENTER_REMARK' | translate}}"></textarea>
                        </RemarksPopupTrigger>
                    </div>

                    <div class="form-group">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="reopen_Reassign_Auto" name="reopen_Reassign" class="custom-control-input" [value]="true" [(ngModel)]="Model.IsAutoAssign" (change)="onAssignmentChange()">
                            <label class="custom-control-label" for="reopen_Reassign_Auto" translate>LBL.AUTO_ASSIGN</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="reopen_Reassign_Manual" name="reopen_Reassign" class="custom-control-input" [value]="false" [(ngModel)]="Model.IsAutoAssign" (change)="onAssignmentChange()">
                            <label class="custom-control-label" for="reopen_Reassign_Manual" translate>LBL.MANUAL_ASSIGNMENT</label>
                            <div class="ml-2" *ngIf="Model.IsAutoAssign == false"><span translate>LBL.ASSIGN_TO</span>: <span>{{AssignToName}} <a href="javascript:{}" (click)="onAssignmentChange()"><span translate>LBL.CHANGE</span></a></span></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="modal-footer">
            <button class="btn btn-primary" type="submit" [disabled]="IsSubmitting" translate>BTN.BTN_OK</button>
            <button class="btn btn-secondary" type="button" (click)="c('')" translate>BTN.BTN_CANCEL</button>
        </div>
    </form>
</ng-template>

<ManualAssign *ngIf="Model" #manualAssign [Mode]="Model.Operation" (SelectedStaffChanged)="onSelectedStaff($event)"></ManualAssign>

<ng-template #confirm let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_CONFIRMATION</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid" *ngIf="ConfirmModel">
        <div class="form-group">
            <div *ngFor="let row of ConfirmModel;let i = index" class="row pointer" [ngClass]="{'border-bottom mb-2 pb-2': (ConfirmModel.length>1 && (i != ConfirmModel.length -1))}" (click)="OpenWindow('/Pages/ComplaintPrint?ComplainID='+row.ComplainId)">
                <div class="col-1 text-center"><div class="statusIcon-{{row.CurrentStatus}}" title="{{'TITLE.TITLE_CALLSTATUS_'+row.CurrentStatus | translate}}"><i class="fas fa-circle"></i></div></div>
                <div class="col-1 pl-0 pr-0 entryIcon text-center" title="{{'TITLE.TITLE_CALL_NO' | translate}}">{{row.DisplayCallNo}}</div>
                <div class="col-3 pr-0 grdCol ">
                    <div class="ellipsis mb-1" title="{{row.LocationName}}"><i class="fas fa-map-marker-alt"></i>&nbsp;{{row.LocationName}}</div>
                    <div [hidden]="!row.RequestedByGuestId" class="ellipsis text-muted " title="{{('TITLE.TITLE_GUEST_NAME' | translate) + ' - '+ row.RequestedByGuestName}}"><span class="" [ngClass]="{'ic-status active': row.Vip}"><i class="fas fa-briefcase"></i></span> {{row.RequestedByGuestName}}</div>
                </div>
                <div class="col-3 pr-0 grdCol ">
                    <div class="ellipsis mb-1">
                        <span class="fa-fw" [hidden]="row.NoOfAttachments == 0 || row.NoOfAttachments == null" title="{{row.NoOfAttachments > 0 ? (('TITLE.TITLE_ATTACHMENTS' | translate) + ' - ' + row.NoOfAttachments) : ('TITLE.TITLE_NO_ATTACHMENTS' | translate)}}"><i class="fas fa-paperclip"></i>&nbsp;</span>
                        <span title="{{row.CallDescription}}">{{row.CallDescription}}</span>
                    </div>
                    <div *ngIf="row.AssignedTo > 0" class="ellipsis text-muted" title="{{('TITLE.TITLE_ASSIGNED_STAFF' | translate) + ' - ' + row.AssignToName}}">
                        {{row.AssignToName}}
                    </div>
                    <div *ngIf="row.AssignedTo == null" class="text-muted text-danger" title="{{'TITLE.TITLE_UNASSIGNED' | translate}}">&nbsp;<span translate>LBL.UNASSIGNED</span></div>

                </div>
                <div class="col-2 pr-0 text-center">
                    <div class="mb-1 text-left" title="{{'TITLE.TITLE_ETA_TEXT' | translate}}"><i class="fas fa-user-clock"></i>&nbsp;{{row.EstimatedTimeToAttendText ? (row.EstimatedTimeToAttendText | translate) : (row.CurrentStatus == 'CLS' ? '' : ('LBL.UNKNOWN' | translate))}}</div>
                    <div class="consoleRemarks ellipsis text-left" [hidden]="!row.LastRemarks || row.LastRemarks.length == 0" title="{{row.LastRemarks}}"><i class="far fa-sticky-note"></i>&nbsp;{{row.LastRemarks}}</div>
                </div>
                <div class="col-2 " title="{{'TITLE.TITLE_MRT' | translate}}"><span translate>{{row.MRTText ? row.MRTText : 'LBL.UNKNOWN'}}</span></div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" type="button" (click)="c('')" translate>BTN.BTN_DISMISS</button>
    </div>
</ng-template>





